import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageContext';

export default function Hero() {
  const { t } = useLanguage();
  const h = t.hero;

  return (
    <section className="hero-section">
      <div className="hero-bg-image">
        <img src={`${process.env.PUBLIC_URL}/Assets/img/hero-banner.jpg`} alt="" />
      </div>
      <div className="hero-bg-overlay" />
      <div className="hero-grid-bg" />
      <div className="hero-glow" />
      <div className="hero-inner container">
        <div className="hero-content">
          <div className="hero-badge">{h.badge}</div>
          <h1 className="hero-title">
            {h.titlePre}<em>{h.titleEm}</em>{h.titlePost}
          </h1>
          <p className="hero-desc">{h.desc}</p>
          <div className="hero-btns">
            <a href="#products" className="btn-primary">{h.exploreBtn}</a>
            <Link to="/contact" className="btn-secondary">{h.demoBtn}</Link>
          </div>
          <div className="hero-stats">
            {h.stats.map(s => (
              <div className="stat-box" key={s.label}>
                <div className="stat-num">{s.num}<span>{s.suffix}</span></div>
                <div className="stat-label">{s.label}</div>
              </div>
            ))}
          </div>
        </div>

        <div className="hero-visual">
          {h.visual.map((v, i) => (
            <div className={`vis-card${i === 0 ? ' span-2' : ''}`} key={v.title}>
              <h4>{v.title}</h4>
              <p>{v.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
